module.exports = __webpack_public_path__ + "img/updategbwhatsapp.998e720b.webp";